import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { UnitProvider } from '@/contexts/UnitContext'
import { TranslationProvider } from '@/contexts/TranslationContext'
import { ThemeProvider } from '@/contexts/ThemeContext'

// Pages
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import Signup from '@/pages/Signup'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import Dashboard from '@/pages/Dashboard'
import Profile from '@/pages/Profile'
import Onboarding from '@/pages/Onboarding'
import Units from '@/pages/Units'
import UnitEdit from '@/pages/UnitEdit'
import UnitMembers from '@/pages/UnitMembers'
import AssetsLayout from '@/pages/AssetsLayout'
import TableDemo from '@/pages/TableDemo'
import SettingsLayout from '@/pages/SettingsLayout'
import BillingLayout from '@/pages/BillingLayout'
import PricingLayout from '@/pages/PricingLayout'

function App() {
  return (
    <AuthProvider>
      <UnitProvider>
        <TranslationProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/units" element={<Units />} />
              <Route path="/units/:unitId/edit" element={<UnitEdit />} />
              <Route path="/units/:unitId/members" element={<UnitMembers />} />
              <Route path="/assets/*" element={<AssetsLayout />} />
              <Route path="/billing/*" element={<BillingLayout />} />
              <Route path="/pricing/*" element={<PricingLayout />} />
              <Route path="/table-demo" element={<TableDemo />} />
              <Route path="/settings/*" element={<SettingsLayout />} />
            </Routes>
          </ThemeProvider>
        </TranslationProvider>
      </UnitProvider>
    </AuthProvider>
  )
}

export default App
